import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import Card from '../../Card/Card';
import PaymentOrdersList from '../PaymentOrdersList';
import Pagination from '../../Pagination/Pagination';
import PaymentOrdersForm from '../PaymentsOrdersForm/PaymentsOrdersForm';
const View = ({
  data: {
    loading,
    page,
    sessionId,
    type,
    error,
    status,
    currencies,
    balance,
    orders,
    pageCount,
    timeDiff,
    purses,
    rules,
    tabProps,
    isMember,
    wallets,
    transport,
    toCurrency,
    selectedCurrency,
    cancelRequestStatus,
  },
  onSubmit,
  showAlertPayment,
  messageAlert,
  setMessageAlert,
  setShowAlertPayment,
  onCurrencyChange,
  onPageChange,
  isUserQuar,
  resetFormState,
  onCancelPaymentClick,
}) => {
  const { history } = tabProps;
  const $el = useRef(null);
  return (
    <div className="payment-orders">
      <Card.Body className="no-padding">
        <PaymentOrdersForm
          transport={transport}
          resetFormState={resetFormState}
          authType={type}
          loading={loading}
          purses={purses}
          rules={rules}
          wallets={wallets}
          showAlertPayment={showAlertPayment}
          setMessageAlert={setMessageAlert}
          messageAlert={messageAlert}
          setShowAlertPayment={setShowAlertPayment}
          currencies={currencies}
          balance={balance}
          onSubmit={onSubmit}
          onCurrencyChange={onCurrencyChange}
          error={error}
          status={status}
          sessionId={sessionId}
          validTill={timeDiff}
          history={history}
          isMember={isMember}
        />

        {orders.length > 0 ? (
          <PaymentOrdersList
            payments={orders}
            onCancelPaymentClick={onCancelPaymentClick}
            cancelRequestStatus={cancelRequestStatus}
          />
        ) : (
          <div className="card-empty">
            <FormattedMessage id="payments.no_payments" defaultMessage="No Payments" />
          </div>
        )}
      </Card.Body>

      {pageCount > 1 && (
        <Card.Footer>
          <Pagination
            pageCount={pageCount}
            onPageChange={onPageChange}
            activePage={page + 1}
            scrollToAfterPageChanged={{ ref: $el.current }}
          />
        </Card.Footer>
      )}
    </div>
  );
};
export default View;
